import { memo } from 'react';
import { Outlet } from 'react-router-dom';
// Local files
import AppNavigation from '../AppNavigation/AppNavigation';
import CableController from 'components/Controllers/Cable/Cable';
import SessionController from 'components/Controllers/Session/Session';
import DeleteDialog from 'components/Dialogs/Delete/Delete';

const Layout = () => {
  return (
    <>
      <AppNavigation />
      <DeleteDialog />
      <CableController />
      <SessionController />
      <Outlet />
    </>
  );
}

export default memo(Layout);